import { AxiosPromise } from "axios";
import { ApiRequestAdapter } from "../../common/api/ApiRequestAdapter";
import { apiService } from "../../common/api/apiService";
import { HttpContentType, HttpHeaders, HttpMethod } from "../../common/api/http";
import { EntityIdObject, EntityObject } from "../../common/types";
import type { UUID } from "../../typings/global";
import {
  ClientPartnerConfig,
  CreateMultiplePartnerConfigs,
  LogoutFromPartnerSso,
  PartnerConfig,
  PartnerConfigBackgroundPicture,
  PartnerConfigsAndSsoProperties,
  PartnerSso,
  RequestPartnerSso,
  RequestPartnerSsoAuthRedirectUrl,
  UpdateMultiplePartnerConfigs,
} from "./types";

const GET_PARTNER_CONFIGS_AND_SSO_PROPS = ApiRequestAdapter.create("/partner-configs", HttpMethod.GET);
const GET_PARNTER_CONFIGS_FOR_SPECIFIC_CLIENT = ApiRequestAdapter.create(
  "/partner-configs/clients/{0}",
  HttpMethod.GET,
);
const CREATE_PARTNER_CONFIGS = ApiRequestAdapter.create("/partner-configs", HttpMethod.POST);
const UPDATE_PARTNER_CONFIGS = ApiRequestAdapter.create("/partner-configs", HttpMethod.PUT);
const DELETE_PARTNER_CONFIGS = ApiRequestAdapter.create("/partner-configs/delete", HttpMethod.POST);
const UPDATE_PARTNER_CONFIG_BACKGROUND_PICTURE = ApiRequestAdapter.create(
  "/partner-configs/{0}/background-picture",
  HttpMethod.PUT,
);
const DELETE_PARTNER_CONFIG_BACKGROUND_PICTURE = ApiRequestAdapter.create(
  "/partner-configs/{0}/background-picture",
  HttpMethod.DELETE,
);

const GET_PARTNER_SSO = ApiRequestAdapter.create("/partner-sso", HttpMethod.PUT);
const LOGOUT_FROM_PARTNER_SSO = ApiRequestAdapter.create("/partner-sso/logout", HttpMethod.PUT);
const MONLY_AUTHORIZATION_CODE_GRANT = ApiRequestAdapter.create("/partner-sso/monly-auth-code", HttpMethod.PUT);

const GET_AUTH_REDIRECT_URL = ApiRequestAdapter.create("/partner-sso-oauth/auth-code-url", HttpMethod.GET);

export const partnerApi = {
  getPartnerConfigsAndSsoProps: (): AxiosPromise<PartnerConfigsAndSsoProperties> => {
    return apiService.get(GET_PARTNER_CONFIGS_AND_SSO_PROPS.url);
  },
  getPartnerConfigsForSpecificClient: (request: EntityIdObject): AxiosPromise<ClientPartnerConfig[]> => {
    return apiService.get(GET_PARNTER_CONFIGS_FOR_SPECIFIC_CLIENT.getParametrizedUrl(request.id));
  },
  createPartnerConfigs: (request: CreateMultiplePartnerConfigs): AxiosPromise<PartnerConfig[]> => {
    return apiService.post(CREATE_PARTNER_CONFIGS.url, request);
  },
  updatePartnerConfigs: (request: UpdateMultiplePartnerConfigs): AxiosPromise<PartnerConfig[]> => {
    return apiService.put(UPDATE_PARTNER_CONFIGS.url, request);
  },
  deletePartnerConfigs: (request: UUID[]): AxiosPromise => {
    return apiService.post(DELETE_PARTNER_CONFIGS.url, request);
  },
  updatePartnerConfigBackgroundPicture: (
    request: EntityObject<FormData>,
  ): AxiosPromise<PartnerConfigBackgroundPicture> => {
    return apiService.put(UPDATE_PARTNER_CONFIG_BACKGROUND_PICTURE.getParametrizedUrl(request.id), request.object, {
      headers: { [HttpHeaders.CONTENT_TYPE]: HttpContentType.MULTIPART_FORM_DATA },
    });
  },
  deletePartnerConfigBackgroundPicture: (request: EntityIdObject): AxiosPromise => {
    return apiService.delete(DELETE_PARTNER_CONFIG_BACKGROUND_PICTURE.getParametrizedUrl(request.id));
  },
  getPartnerSso: (request: RequestPartnerSso): AxiosPromise<PartnerSso> => {
    return apiService.put(GET_PARTNER_SSO.url, request);
  },
  logoutFromPartnerSso: (request: LogoutFromPartnerSso): AxiosPromise => {
    return apiService.put(LOGOUT_FROM_PARTNER_SSO.url, request);
  },
  monlyAuthorizationCodeGrant: (code: string): AxiosPromise<PartnerSso> => {
    return apiService.put(MONLY_AUTHORIZATION_CODE_GRANT.url, null, {
      params: { code },
    });
  },
  getAuthRedirectUrl: (request: RequestPartnerSsoAuthRedirectUrl): AxiosPromise<string> => {
    return apiService.get(GET_AUTH_REDIRECT_URL.url, { params: request });
  },
};
